import React from "react";
import "./styles.scss";
import { InfoSection, OfferBanner } from "../../components";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { changeTab } from "../../actions/general";
import SEO from "../../components/SEO/SEO";
import { useTranslation } from "react-i18next";

export default function Info() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0, { behavour: "smooth" });
    dispatch(changeTab("info"));
  }, [dispatch]);

  return (
    <>
      <SEO
        title={`${t("general.headerUsefulInfo")} | Synergon Energy`}
        name={`${t("general.headerUsefulInfo")} | Synergon Energy`}
        description={t("articlesInfo.articlesInfoSubtitle")}
        type={"website"}
        breadcrumbs={[
          { name: "Synergon Energy", url: "/" },
          { name: t("general.headerUsefulInfo"), url: "/info" },
        ]}
      />
      <div className="screen-wrapper info">
        <div className="screen-inner-wrapper">
          <h1 className="sr-only">{t("general.headerUsefulInfo")}</h1>
          <InfoSection />
          <OfferBanner />
        </div>
      </div>
    </>
  );
}
